import { ActionTypes } from "@/actions";
import { dataAPI } from "@/app/api/dataApi";
import { all, call, put, takeEvery } from "redux-saga/effects";

const workerStartEditComponent = function* (action: any): Generator<any, void, any> {
    try {
    } catch (error: any) {
        console.error('workerStartEditComponent', error);
    }
}

const workerComponentValueUpdated = function* (action: any) {
    try {
        put({ type: ActionTypes.EDIT_COMPONENT_VALUE_UPDATED, payload: action.payload });
    } catch (error: any) {
        console.error('workerComponentFieldValueUpdated', error);
    }
}

const workerComponentSetMeta = function* (action: any) {
    try {
        put({ type: ActionTypes.EDIT_COMPONENT_FIELD_UPDATED, payload: { key: 'uid', value: action.payload.uid } });
        put({ type: ActionTypes.EDIT_COMPONENT_FIELD_UPDATED, payload: { key: 'mongoCollection', value: action.payload.collection } });
    } catch (error: any) {
        console.error('workerComponentSetMeta', error);
    }
}

const workerComponentFieldValueUpdated = function* (action: any) {
    try {
        put({ type: ActionTypes.EDIT_COMPONENT_FIELD_UPDATED, payload: action.payload });
    } catch (error: any) {
        console.error('workerComponentFieldValueUpdated', error);
    }
}

const workerNewComponent = function* (action: any) {
    try {
        put({ type: ActionTypes.EDIT_COMPONENT_START, payload: action.payload });
    } catch (error: any) {
        console.error('workerNewComponent', error);
    }
}

const workerComponentDelete = function* (action: any): Generator<any, void, any> {
    try {
        const response = yield call([dataAPI, 'deleteComponent'], action.payload);
        yield put({ type: ActionTypes.DELETE_ITEM_SUCCESS, payload: response.deletedComponent });
        yield put({ type: ActionTypes.COMPONENTS_REQUEST, payload: { force: true } });
    } catch (error: any) {
        console.error('❌ workerComponentDelete error:', error);
        yield put({ type: ActionTypes.DELETE_ITEM_ERROR, payload: error.message });
    }
}

const workerComponentFieldNew = function* (action: any) {
    try {
        console.log('workerComponentFieldNew', action.payload);
    } catch (error: any) {
        console.error('workerComponentFieldNew', error);
    }
}

const workerComponentUpdateState = function* (action: any) {
    try {
        console.log('workerComponentUpdateState', action.payload);
    } catch (error: any) {
        console.error('workerComponentUpdateState', error);
    }
}




export function* watcherStartEditComponent() {
    yield all([
        takeEvery(ActionTypes.EDIT_COMPONENT_START, workerStartEditComponent),
        takeEvery(ActionTypes.EDIT_COMPONENT_NEW, workerNewComponent),
        takeEvery(ActionTypes.EDIT_COMPONENT_VALUE_UPDATED, workerComponentValueUpdated),
        takeEvery(ActionTypes.EDIT_COMPONENT_FIELD_UPDATED, workerComponentFieldValueUpdated),
        takeEvery(ActionTypes.EDIT_COMPONENT_FIELD_NEW, workerComponentFieldNew),
        takeEvery(ActionTypes.EDIT_COMPONENT_FIELD_DELETE, workerComponentFieldNew),
        takeEvery(ActionTypes.EDIT_COMPONENT_UPDATE_STATE, workerComponentUpdateState),
        takeEvery(ActionTypes.COMPONENT_DELETE, workerComponentDelete),
        takeEvery(ActionTypes.EDIT_COMPONENT_SET_META, workerComponentSetMeta),
    ])
}
